<template>
  <div>
    <ClientHeader :cid="cid" :sid="sid"/>
    <section class="top-wrap">
      <div class="container">
        <div class="top-wrap__headers">
          <h2
            class="top-wrap__title"
            :class="{'is-active': !type.id}"
            @click="closeByBreadcrubs()"
          >
            {{ type && type.id ? type.category : 'Тип услуги' }}
          </h2>
          <h2 v-if="type.id" class="top-wrap__title is-active">
            /{{ subTitle }}
          </h2>
        </div><!---
        <form action="#" class="top-wrap__form">
          <input type="text" class="top-wrap__input" placeholder="Поиск">
          <button class="top-wrap__btn" type="button">
            <i class="material-icons">search</i>
          </button>
        </form>
        -->
      </div>
    </section>
    <section class="client-service">
      <div class="container">
<!--        <ul>-->
<!--          <li><b>1</b>{{service}}</li>-->
<!--          <li><b>2</b>{{service.isActive}}</li>-->
<!--          <li><b>3</b>{{service.options}}</li>-->
<!--          <li v-if="service.options && service.options.length">4{{service.options.length}}</li>-->
<!--        </ul>-->
        <div class="client-service__wrap" :class="{'is-active': service && service.isActive}">
          <ServiceTypes
            @onTypeClick="onClick"
            @onSubTypeClick="onClick"
            @onServiceClick="onClick"
            @onSubServiceClick="onClick"
            :sid="sid"
            :cid="cid"
            :type="type"
            :subType="subType"
            :service="service"
            :subService="subService"
          />
          <!-- Aside -->
          <div class="client-service-aside">
            <!--TODO: fix this functionality in the feature
               <div class="client-service-aside__wrap client-service-pop">
                 <h2 class="client-service-aside__title">Популярное</h2>

                <PopularServices/>

               </div>
              -->
             <!-- <div class="client-service-aside__wrap client-service-pop">
               <h2 class="client-service-aside__title">Вы недавно выбирали</h2>
               <PopularServices/>
             </div>-->
            <!-- <div class="client-service-aside__wrap client-service-recent">
              <h2 class="client-service-aside__title">Вы недавно выбирали</h2>
              <a href="#" class="client-service-aside__item">
                <h3 class="client-service-aside__subtitle">Окрашивание волос</h3>
                <span class="client-service-aside__price">цена</span>
                <span class="client-service-aside__price">цена</span>
                <span class="client-service-aside__price">цена</span>
              </a>
              <a href="#" class="client-service-aside__item">
                <h3 class="client-service-aside__subtitle">Мелирование волос</h3>
                <span class="client-service-aside__price">цена</span>
                <span class="client-service-aside__price">цена</span>
                <span class="client-service-aside__price">цена</span>
              </a>
            </div>-->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ClientHeader from "@/components/ClientHeader.vue";
import ServiceTypes from "@/components/ServiceTypes.vue";
import PopularServices from "@/components/PopularServices.vue";

import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "client-service",
  components: {
    ClientHeader,
    ServiceTypes,
    PopularServices
  },
  props: ['sid', 'cid'],
  data () {
    return {
      type: {},
      subType: {},
      service: {},
      subService: {},
    }
  },
  computed: {
    ...mapState("client", ["currentSalonId", "customer", "companySettings"]),
    ...mapGetters("salons", ["getSalonServices"]),
    ...mapGetters("client", ["getCustomer"]),
    services() {
      return this.getSalonServices(this.currentSalonId);
    },
    subTitle() {
      return (this.subType && this.service && this.service.name) ? `${this.subType.category}/${this.service.name}` : (this.subType.category || 'Подкатегория услуг')
    }
  },
  mounted(){
    this.clearServiceInProgress();
  },
  methods: {
    ...mapActions("salons", ["fetchSalon"]),
    ...mapActions("client", ["selectGender", "clearServiceInProgress"]),
    onClick (data) {
      if (data && data.name) {
        if (data.obj && data.obj.id) this[data.name] = {}
        this[data.name] = data.obj
      } else return
    },
    closeByBreadcrubs () {
      const unActive = {
        id: null,
        isActive: false
      }
      this.subType = unActive;
      this.service = unActive;
      this.subService = unActive;
    }
  },
  async beforeMount () {
    let isGender = (this.companySettings && this.companySettings.is_genderable_services) ? (this.getCustomer && this.getCustomer.gender) : true
    if (!(this.currentSalonId && isGender)) return this.$router.replace(`/company/${this.$route.params.cid}`)

    if (!(this.companySettings && this.companySettings.is_genderable_services))
      await this.selectGender({ salonId: this.currentSalonId, gender: '' })
  }
};
</script>
<style lang="sass">
// width
=r($width)
  @media only screen and (max-width: $width+ "px")
    @content

=rmin($width)
  @media only screen and (min-width: $width+ "px")
    @content

// height
=rh($height)
  @media only screen and (max-height: $height + "px")
    @content

=rhmin($height)
  @media only screen and (min-height: $height + "px")
    @content
// LAYOUT
$mobile-s: 375
$mobile: 568
$tablet: 767
$desktop: 992
$wide: 1336
$hd: 1440

// COLORS
$text-18: #181818
$text-36: #363636

// OPTIONS
$transitSpeed: .2s
$ease: ease-in-out


// topbar: titles and search
.top-wrap
  margin-top: 20px
  margin-bottom: 30px
  .container
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: center
  &__headers
    flex-grow: 1
    margin-right: 20px
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: flex-start
    align-items: center
    overflow-x: auto
    overflow-y: hidden
    scrollbar-width: 0
    scrollbar-color: rgba(255,255,255,0)
    &::-webkit-scrollbar
      width: 0px
      height: 0
      background: rgba(255, 255, 255, 0)
  &__title
    margin: 0
    flex: 0 0 auto
    font-size: 18px
    font-weight: 500
    color: rgba(0,0,0,0.5)
    &.is-active,
    &:hover
      color: $text-36
      cursor: pointer
  &__form
    position: relative
    min-width: 445px
  &__input
    display: block
    width: 100%
    border-radius: 14px
    border: 0
    box-shadow: 0
    padding: 10px 45px 10px 15px
    background-color: #f4f4f4
    font-size: 16px
    color: $text-36
  &__btn
    position: absolute
    top: 50%
    right: 15px
    transform: translateY(-45%)
    color: $text-36
    border: 0
    padding: 0
    background-color: transparent
    opacity: 0.3
    transition: all $transitSpeed
    &:hover
      cursor: pointer
      opacity: 1
    i
      font-size: 20px
// main and type
.client-service
  .container
    overflow-x: hidden
    padding-top: 10px
    padding-bottom: 10px
  &__wrap
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: stretch
    height: calc(100vh - 190px)
    transition: all $transitSpeed
    &.is-active
      transform: translateX(-320px)
.client-service__main
  width: calc(60% - 10px)
  position: relative

.client-service-type
  display: flex
  flex-direction: row
  flex-wrap: wrap
  justify-content: space-between
  transition: all $transitSpeed
  position: relative
  z-index: 1
  &.is-hidden
    transform: translateX(-150px)
    opacity: 0
    visibility: hidden
    z-index: -10

.main-type-item
  border: 1px solid #e5e5e5;
  width: 49%
  border-radius: 8px
  margin-bottom: 20px
  transition: all $transitSpeed
  background-color: #fff
  padding: 20px 25px
  &:hover
    background-color: $text-36
    cursor: pointer
    color: #fff
  &__title
    margin-top: 0
    margin-bottom: 10px
    font-size: 16px
    font-weight: 500
  &__amount
    font-size: 12px
    font-weight: 400
    margin: 0

// Aside: popular, recent
.client-service-aside
  width: calc(40% - 10px)
  &__wrap
    margin-bottom: 35px
    &:last-child
      margin-bottom: 0
  &__title
    font-size: 18px
    font-weight: 500
    margin-top: 0
    margin-bottom: 25px
  &__item
    display: block
    width: 100%
    margin-bottom: 10px
    border-radius: 8px
    padding: 13px
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: flex-start
    align-items: center
    background-color: $text-36
    transition: all $transitSpeed
    color: #fff
    &:hover
      cursor: pointer
  &__subtitle
    font-size: 10px
    margin: 0
    font-weight: 400
    margin-right: auto
  &__price
    font-size: 10px
    font-weight: 400
    margin-left: 15px

// Subtype
.client-service-subtype
  position: absolute
  display: flex
  min-height: 350px
  flex-direction: column
  max-height: 100%
  height: 100%
  top: 0
  left: 0
  width: 85%
  //max-width: 480px
  z-index: 3
  background-color: #fff
  padding: 20px 25px
  box-shadow: 2px 2px 15px rgba(0,0,0,0.1)
  border-radius: 8px
  transition: all $transitSpeed, opacity 0.1s
  transform: translateX(100px)
  opacity: 0
  visibility: hidden
  &.is-active
    opacity: 1
    visibility: visible
    transform: translateX(0)
  &__header
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: flex-start
    margin-bottom: 25px
    position: relative
    > i
      display: none
      position: absolute
      font-size: 14px
      color: $text-36
      top: 50%
      left: -5px
      transform: translateY(-50%)
  &__title-wrap
    margin-right: auto
  &__title
    font-size: 18px
    margin-top: 0
    margin-bottom: 4px
    font-weight: 500
  &__amount
    font-size: 12px
    font-weight: 400
    margin: 0
    color: $text-36
  &__btn
    background-color: transparent
    padding: 0
    border: 0
    position: relative
    font-size: 14px
    color: $text-36
    padding-right: 30px
    margin-left: auto
    &:hover
      cursor: pointer
    i
      position: absolute
      top: 50%
      right: 0
      font-size: 18px
      transform: translateY(-50%)
  &__main
    overflow-y: auto
    height: calc(100% - 60px)
  &__item
    padding: 12px 15px
    border-radius: 8px
    background-color: #fff
    font-size: 12px
    font-weight: 500
    color: $text-36
    transition: all $transitSpeed
    margin-bottom: 15px
    &:hover
      background-color: $text-36
      color: #fff
      cursor: pointer


// one service
.client-one-service
  position: absolute
  top: 0
  left: 85%
  width: 100%
  min-height: 350px
  max-width: 485px
  transition: all $transitSpeed, opacity 0.1s
  z-index: 2
  background-color: #fff
  // padding: 20px 25px
  //box-shadow: 2px 2px 15px rgba(0,0,0,0.1)
  border-radius: 8px
  max-height: 100%
  height: 100%
  display: -webkit-flex
  display: -ms-flex
  display: flex
  flex-direction: column
  transform: translateX(100px)
  opacity: 0
  visibility: hidden
  &.is-active
    visibility: visible
    opacity: 1
    transform: translateX(0)

  &__main-info
    position: relative
    z-index: 2
    max-height: 90%
    padding: 20px 25px
    background-color: #fff
    box-shadow: 2px 2px 15px rgba(0,0,0,0.1)
    border-radius: 8px
    overflow-y: auto
  &__price
    float: right
  &__header
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 25px
    position: relative
    z-index: 2
    background-color: #fff
    > i
      display: none
      position: absolute
      font-size: 14px
      color: $text-36
      top: 50%
      left: -5px
      transform: translateY(-50%)
  &__title
    font-size: 18px
    margin: 0
    font-weight: 500
    margin-right: auto
    padding-right: 10px
  &__amount
    font-size: 12px
    font-weight: 400
    margin: 0
    color: $text-36
  &__btn
    background-color: transparent
    padding: 0
    border: 0
    position: relative
    font-size: 14px
    color: $text-36
    padding-right: 25px
    margin-left: auto
    &:hover
      cursor: pointer
    i
      position: absolute
      top: 50%
      right: 0
      font-size: 18px
      transform: translateY(-50%)
  &__thead
    display: flex
    justify-content: flex-start
    align-items: center
    margin-bottom: 25px
    padding: 0 15px
    position: relative
    z-index: 2
    background-color: #fff
  &__head
    font-size: 12px
    font-weight: 400
    margin: 0
    min-width: 50px
    margin-left: 20px
    text-align: right
    &:nth-child(2)
      margin-left: 0
    &--name
      flex-grow: 1
      margin-right: auto
      margin-left: 0
      text-align: left
  &__tbody
    overflow-y: auto
    height: calc(100% - 20px)
    position: relative
    z-index: 2
    background-color: #fff
    padding-bottom: 50px
    .client-one-service_tbody_sub_service
      margin-bottom: 15px
  &__sub-service
    display: none
    // display: -ms-flex
    // display: -webkit-box
    // display: -ms-flexbox
    // display: flex
    -webkit-box-pack: start
    -ms-flex-pack: start
    justify-content: flex-start
    -webkit-box-align: center
    -ms-flex-align: center
    align-items: center
    border-radius: 8px
    background-color: #fff
    padding: 1px 35px
    color: #363636
    -webkit-transition: all 0.2s
    transition: all 0.2s
    margin-bottom: 15px
    margin-top: 15px
  &__sub-individual
    input
      display: none
      &:checked + .client-one-service__sub-service-item
        background-color: $text-36
        color: #fff
        cursor: pointer
        i
          display: flex
  &__sub-individual
    flex: 1
  &__sub-service-item
    flex: 1
    display: flex
    flex-direction: column
    margin-left: 10px
    margin-right: 10px
    padding: 5px 0px
    border-radius: 10px
    &:hover
      background-color: $text-36
      color: #fff
      cursor: pointer
    .client-one-service__price
      flex: 1
  &__item
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: flex-start
    align-items: center
    border-radius: 8px
    background-color: #fff
    padding: 13px 15px
    color: $text-36
    transition: all $transitSpeed
    &:hover
      background-color: $text-36
      color: #fff
      cursor: pointer
      i
        display: flex
    i
      flex: 0 0 auto
      width: 12px
      height: 12px
      display: none
      margin-right: 5px
      justify-content: center
      align-items: center
      border-radius: 50%
      background-color: #fff
      color: $text-36
      font-size: 10px
  input
    display: none
    &[name="client-one-service__sub"]:checked + .client-one-service__item
      background-color: $text-36
      color: #fff
      cursor: pointer
      i
        display: flex
    &[name="client-one-service__sub"]:checked ~ label
      color: red
    &[name="client-one-service__sub"]:checked + .client-one-service__sub-service
      display: flex
  &__name
    margin: 0
    margin-right: auto
    font-size: 12px
    font-weight: 500
    flex-grow: 1
    transition: position $transitSpeed
  &__price
    font-size: 12px
    font-weight: 500
    min-width: 50px
    text-align: center
    // &:first-of-type
    //   margin-bottom: 10px
  &__btns
    display: none
    justify-content: flex-end
    align-items: center
    background-color: rgba(255,255,255,0.9)
    padding: 5px 25px
    // position: absolute
    z-index: 2
    bottom: 35px
    left: 0
    width: 100%
    &.is-active
      display: flex
  &__cancel
    display: inline-block
    background-color: transparent
    border: 0
    padding: 0
    font-size: 14px
    font-weight: 400
    &:hover
      cursor: pointer
      text-decoration: underline
  &__next
    display: inline-block
    margin-left: 15px
    text-align: center
    color: #fff
    background-color: $text-36
    border-radius: 8px
    font-size: 14px
    font-weight: 400
    padding: 9px 15px
    border: 1px solid transparent
    transition: all $transitSpeed
    &:hover
      border-color: $text-36
      color: $text-36
      background-color: #fff
      cursor: pointer
    &[disabled]
      background-color: gray
      cursor: not-allowed
      pointer-events: none
      &:hover
        color: #fff
        border: 1px solid transparent

.client-one-parametrs
  position: absolute
  top: 0
  left: 100%
  height: inherit
  background-color: #fff
  padding: 20px 25px
  box-shadow: 2px 2px 15px rgba(0,0,0,0.1)
  border-radius: 8px
  transition: $transitSpeed, opacity 0.1s
  z-index: 1
  max-height: 90%
  width: 100%
  max-width: 320px
  visibility: hidden
  opacity: 0
  transform: translateX(-320px)
  &.is-active
    visibility: visible
    opacity: 1
    transform: translateX(0px)
  .client-one-service__btns
    display: flex !important
  .client-one-service__summary
    display: flex !important
    margin-top: 15px
    .summary-amount
      flex: 1
    .summary-label
      flex: 1
  &__title-wrap
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: flex-start
    margin-bottom: 23px
    position: relative
    > i
      display: none
      position: absolute
      font-size: 14px
      color: #363636
      top: 50%
      left: -5px
      -webkit-transform: translateY(-50%)
      -ms-transform: translateY(-50%)
      transform: translateY(-50%)
  &__title
    font-size: 16px
    font-weight: 500
    margin: 0
    color: #000
    padding-right: 10px
  &__block
    margin-bottom: 40px
  &__subtitle
    margin-top: 0
    margin-bottom: 25px
    font-weight: 400
    font-size: 14px
    color: $text-36
  &__tbody
    height: calc(100% - 90px);
  &__label
    display: block
    font-size: 14px
    font-weight: 400
    color: $text-18
    padding-right: 30px
    position: relative
    width: 100%
    &:before
      content: ''
      position: absolute
      transform: translateY(-50%)
      top: 50%
      right: 0
      width: 24px
      height: 24px
      background-color: #f7f7f7
      background-repeat: no-repeat
      background-size: 70% 70%
      background-position: 50% 50%
    &--check:before
      border-radius: 8px
    &--radio:before
      border-radius: 50%
    &:hover
      cursor: pointer
  &__inputs
    margin-bottom: 17px
    input
      display: none
      &:checked + .client-one-parametrs__label--radio:before
        background-image: radial-gradient(at center, #4d4d4d 50%, transparent 50%, transparent 100%)
    .client-one-parametrs__label--check.checked:before
      background-image: url(../assets/img/check.svg)

+r($desktop)
  .client-one-service
    width: 90%
    &__main-info
      padding: 20px 17px
    &__item
      padding: 11px 13px
  .client-one-parametrs
    padding: 20px 17px

+r($tablet)
  .top-wrap
    &__form
      min-width: 200px
  .client-service
    &__wrap
      &.is-active
        transform: translateX(0)
    &-aside
      display: none
    &__main
      width: 100%
  .client-service-subtype
    width: 100%
  .client-one-service
    left: 0
    width: 100%
    max-width: 100%
    &.is-active
      z-index: 3
    &.last-is-open
      left: 0
      z-index: 3
  .client-one-parametrs
    &.is-active
      left: 0
      z-index: 4
      max-width: 100%

+r($mobile)
  .top-wrap
    display: none
  .client-service
    &__wrap
      height: calc(100vh - 200px)
  .main-type-item
    width: 100%
  .client-service-type
    max-height: 100%
    overflow-y: auto
  .client-service-subtype
    width: calc(100% + 30px)
    margin-left: -15px
    &__btn
      display: none
    &__header
      padding-left: 20px
      i
        display: inline-block
  .client-one-service
    width: calc(100% + 30px)
    max-width: calc(100% + 30px)
    margin-left: -15px
    &__btn
      display: none
    &__header
      padding-left: 20px
      i
        display: inline-block
    &__thead
      display: none
    &__item
      width: 100%
    &__name
      margin-right: auto
    &__tbody
      width: 100%
      overflow-x: hidden
    &__name
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
    &__price
      min-width: 43px
      // margin-left: 13px

  .client-one-parametrs
    &__title-wrap
      padding-left: 15px
      i
        display: inline-block

</style>
